import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/components/Home'
import Map from '@/components/Map'
import Statistics from '@/components/Statistics'

Vue.use(Router)

export default new Router({
    routes: [
        /*{
            path: '',
            name: 'home',
            component: Home
        },*/
        {
            path: '/map',
            name: 'map',
            component: Map
        },
        {
            path: '/statistics',
            name: 'Statistics',
            component: Statistics
        },
        { path: '*', redirect: '/map' }
    ],
    mode: 'history'
}) 